import { Card, Icon } from 'semantic-ui-react'
import './styles.scss'
import Carousel from '../carousel'
import { requerAtencao, sortReportes } from '../../util/reportes'
import { Tag } from '../tag/styles'
import { Link } from 'react-router-dom'
import dayjs from 'dayjs'
import { PropsCardPrioritarioType } from './types'
import { EllipsisParagraph } from '../EllipsisParagraph'
import { Print}  from '../Print'
import chroma from 'chroma-js'
import { useEffect, useState } from 'react'


const CardPrioritario = ({
  id, title, situacao, deliberacao, reportes, atualizado_em,
  novo = false, notificacoes = [],
  tamanhoMaiorSigla = 0,
  setError, showEditar, showRelatar, showResumir, backgroundColor
}: PropsCardPrioritarioType) => {
  const [style, setStyle] = useState<{}>()
  const requer_atencao = requerAtencao(reportes)
  sortReportes(reportes)

  useEffect(() => {
    if (backgroundColor) {
      const boxShadowColor = chroma(backgroundColor).darken(2).hex()
      setStyle({
        backgroundColor: backgroundColor,
        boxShadow: `0px 1px 3px 0px ${boxShadowColor}, 0px 0px 0px 1px ${boxShadowColor}`
      })
    }
  }, [backgroundColor])

  return (
    <Card fluid className={'card-prioritario'} style={style}>
      <Card.Content>
        <Tag className='card-tag'
          requer_atencao={requer_atencao}
          novo={novo}
        />
        <div className={'notificacao'}>
          {notificacoes.map(n => n.tipo).includes('adicionar_relator') &&
            <Icon name="buromobelexperte" title="Adicionar relator" />}
          {notificacoes.filter(n => n.tipo !== 'adicionar_relator').length > 0 &&
            <Icon name="redo"
              title={Array.from(new Set(notificacoes.filter(
                  n => n.tipo !== 'adicionar_relator'
                ).map(
                  n => n.descricao
                ))).join(', ')
              }
            />
          }
          {novo && <div className='novo'>NOVO</div>}
        </div>
        <div>
          <h1 className={'ellipsis'} title={title}>{title}</h1>
        </div>
        <div className='ui grid actions-reports' style={{ padding: 'unset', margin: 'unset' }}>
          <div name="card-acoes" className='left floated seven wide column actions'>
            <Link to={`/prioritario/visualizar/${id}`}>
              <Icon title="Visualizar Resumo e Reportes" name='eye' nameid='vw-card' size='large' />
            </Link>
            {showEditar && <Link to={`/prioritario/editar/${id}`}>
              <Icon title="Editar descrição e situação" name='pencil' nameid='ed-card' size='large' />
            </Link>}
            {showRelatar && <Link to={`/prioritario/relatar/${id}`}>
              <Icon.Group>
                <Icon title="Relatórios" name='square full' nameid='relato-card' size='large' />
                <Icon title="Relatórios" name='bars' nameid='relato-card2' inverted size='small' />
              </Icon.Group>
            </Link>}
            {showResumir && <Link to={`/prioritario/resumir/${id}`}>
              <Icon.Group>
                <Icon title="Resumir" name='file' nameid='resumir-card' size='large' />
                <Icon title="Resumir" name='list' nameid='resumir-card2' inverted size='small' />
              </Icon.Group>
            </Link>}
            <Print  setError={setError} title="Exportar como documento do word" name='btn-imprimir' extensao='docx' template='tema-prioritario' id={id} disabled={false} />
          </div>
          <span className="right floated eight wide column siglaContainer">
            <Carousel reportes={reportes} size={tamanhoMaiorSigla} />
          </span>
        </div>
        <Card.Description>
          <span className='atualizadoEm'>
            {atualizado_em && dayjs(atualizado_em).format('DD/MM HH:MM')}
          </span>
          <div>
            <h3>Situação</h3>
            <EllipsisParagraph rows={3} htmlTitle='Situação' htmlText={situacao} />
          </div>
          <div>
            <h3>Necessidade de apoio</h3>
            <EllipsisParagraph rows={3} htmlTitle='Necessidade de apoio' htmlText={deliberacao} />
          </div>
        </Card.Description>
      </Card.Content>
    </Card>)
}

export default CardPrioritario
